
(function(template){
define('vue!basicComponents/checkBox',['Vue'],function(Vue){
    return {
        template: template,
        data: function(){
            return {
                checked: false,
                haveGuests: false
            }
        },
        props: ['selected','users','user_checkbox','userId','service','userlist'],
        methods: {
            handleKeyDown: function(e){
                this.a11yKeyDown(e,{
                    enter: function() {
                        e.target.click();
                    },
                    space: function() {
                        e.target.click();
                    }
                })
            },
            handleClick: function(e){
                e.stopPropagation();
                if(!!this.userId){
                  
                   this.$emit('handle-Multiple-Click',this.userId,!!!this.selected)
                }else{
                    if(Object.keys(this.users).length>1)
                        //this.$parent.showMemberDropdown = true;
                        this.$emit('toggle-ShowMember-Dropdown',true)
                    else
                        this.$parent.handleSingleAdd(!!!this.selected);
                }
            }
        }

    }
})
})('<div class=\'custom-check-box\' aria-label="check box" tabindex="0" @keydown="handleKeyDown" @click="handleClick"><i v-if="!!selected && !service" class="fas fa-check"></i><i v-if="service" class="icon-plus"></i></div>');
